export const COUNTRIES_ICONS_BASE_URL = window.ENV ? window.ENV.iconBaseUrl : process.env.REACT_APP_ICON_BASE_URL
